require('./alpine.js');

import './carousel.js';
import './account/products.js';

import '../sass/main.scss';
import '../sass/fonts.scss';
import '../sass/confetti.scss';
import '../sass/woobt.scss';
import '../sass/waiting-list.scss';

import logo from '../img/lysiq-logo-simplified.svg'
import logo2 from '../img/lysiq-logo-simplified-2.svg'
import logo3 from '../img/lysiq-logo-simplified-3.svg'
import logo4 from '../img/lysiq-logo-simplified-4.svg'
import symbol from '../img/lysiq-symbol.svg'
import homey from '../img/homey.png'
import futurehome from '../img/futurehome.png'
import lysiq3dsymbol from '../img/lysiq-symbol-3d.jpg'
import lysiq3dsymbol2 from '../img/lysiq-symbol-3d-2.jpg'
import lysiqmenubg from '../img/lysiq-menu-bg.jpg'
import appstoreSwedish from '../img/app-store-swedish.svg'
import googleplaySwedish from '../img/google-play-swedish.png'
import placeholder from '../img/placeholder.jpeg'
import vapeslogo from '../img/vapes-logo-2017-black.svg'

window.onlyOneSearchFilterCheckbox = function (checkbox) {
    var checkboxes = document.getElementsByName('search-filters')
    checkboxes.forEach((item) => {
        if (item !== checkbox) item.checked = false
    })
}


Array.from(document.getElementsByClassName("expander")).forEach(function(element) {
    element.addEventListener('click', (expander) => {
        let target = document.getElementById(element.getAttribute('data-expand'))
        target.classList.remove('hidden');
        element.classList.add('hidden');
    });
  });



/* Cart */ 
jQuery(".crossell-link").on("click", function (e) {
    e.preventDefault();
    const href = jQuery(this).attr("href");
    jQuery("html, body").animate({ scrollTop: jQuery(href).offset().top - 50 }, 800);
});

jQuery(document).on('click', '.ajax_remove_from_cart', function (e) {
    e.preventDefault();

    var product_id = jQuery(this).attr("data-product_id"),
        cart_item_key = jQuery(this).attr("data-cart_item_key"),
        product_container = jQuery(this).parents('.cart-product');

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "product_remove",
            product_id: product_id,
            cart_item_key: cart_item_key,
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
        }
    });
});


jQuery(document).on('change', '.ajax_product_quantity', function (e) {
    e.preventDefault();
    
    jQuery(this).prop('disabled', true)
    jQuery(this).siblings().prop('disabled', true)
    jQuery(this).closest('.cart-product').first().children('.thumbnail').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery(this).closest('.cart-product').first().children('.info').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery(this).closest('.cart-product').first().children('.spinner').first().removeClass('hidden')

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "update_item_from_cart",
            quantity: jQuery(this).val(),
            cart_item_key: jQuery(this).attr("data-cart_item_key"),
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error ) {
                console.log(response.error);
                return;
            }

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );

            jQuery(this).removeClass('loading')

        }
    });
});


jQuery(document).on('change', 'input[name="rate"]', function (e) {
    jQuery('#checkout-cart, #cart-totals, #coupons').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "update_shipping_method",
            shipping_method: jQuery(this).val(),
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
        }
    });
})

jQuery(document).on('click', '#coupon_code_submit', function (e) {
    e.preventDefault();

    var couponCode = jQuery('#coupon_code').val();
    var nonce = jQuery('#coupon_code_nonce').val();

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: 'ajax_apply_coupon',
            coupon_code: couponCode,
            security: nonce
        },
        success: function(response) {
            if ( ! response || response.error ) {
                console.log(response.error);
                return;
            }

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }

            // Update cart
            jQuery( document.body ).trigger( 'applied_coupon_in_checkout' );
        }
    });
});


jQuery('body').on('applied_coupon_in_checkout removed_coupon_in_checkout', function (e) {

    jQuery('#checkout-cart, #cart-totals, #coupons').addClass('loading transition-opacity opacity-10 pointer-events-none')
    
    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "refresh_coupon",
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            //jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
            jQuery('#coupons').removeClass('loading')
        }
    });

});

function setValueUnencoded(url, key, value, action) {
    url.searchParams.set(key, value);
    const entries = Array.from(url.searchParams.entries());
    url.search = "";
    entries.forEach(item => {
        if (item[0] === key) { return; }
        url.searchParams.set(item[0], item[1]);
    });
    url.search += `${key}=${value}`;
}

function processFormForURL(form) {

    let filter = '';
    let filters = {};
    let sorting = '';
    
    form.forEach(element => {
        if (element.name === 'sorting') {
            sorting = element.value;
        }
        if (element.value === '') return;
        if (element.value === 'on') element.value = true;
        if (element.value === 'off') element.value = false;
        if (typeof element.value === "string") {

            element.value = element.value.replace(" ", "%20")
            element.value = element.value.replace("%28", "(")
            element.value = element.value.replace("%29", ")")


            element.value = element.value.replace(/(&|&amp;| )/g, function(match) {
            if (match === ' ') {
                return '%20';
            } else if (match === '%2B') {
                return '+';
            } else {
                return '%26';
            }});
        }

        if (typeof filters[element.name] !== 'undefined') {
            filters[element.name] += "," + element.value;

        } else {
            filters[element.name] = element.value;
        }
    });

    let filterIndex = 0;

    for (const [key, value] of Object.entries(filters)) {
        if (filterIndex > 0) filter += ';';
        filter += key + ':' + value;
        filterIndex++;
    }

    const url = new URL(window.location.href);

    if (filter == '') {
        url.searchParams.delete('query');
    } else {
        if (window.location.href.indexOf("?s=") > -1) {
            setValueUnencoded(url, '&query', filter);
        } else {
            setValueUnencoded(url, 'query', filter);
        }
    }

    window.history.replaceState(null, null, url);

    return {
        'filters': filter,
        'sorting': sorting
    };

}

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

function removeValueFromQueryString(query, key, value) {
    // Split the query by semicolon (;) to get individual key-value pairs
    const keyValuePairs = query.split(';');
  
    // Iterate over each key-value pair
    const updatedKeyValuePairs = keyValuePairs.map((pair) => {
      // Split the pair by colon (:) to get the key and value
      const [pairKey, pairValue] = pair.split(':');
  
      // Check if the pair key and value match the provided key and value
      if (pairKey === key && pairValue.includes(value)) {
        // Split the pair value by comma (,) to get individual values
        const pairValues = pairValue.split(',');
  
        // Remove the provided value from the pair values
        const updatedValues = pairValues.filter((v) => v !== value);
  
        // Join the updated values with comma (,) to form the new pair value
        const updatedPairValue = updatedValues.join(',');
  
        // Return the updated key-value pair
        return `${pairKey}:${updatedPairValue}`;
      }
  
      // Return the original key-value pair if no update is needed
      return pair;
    });
  
    // Join the updated key-value pairs with semicolon (;) to form the new inputString
    const updatedInputString = updatedKeyValuePairs.join(';');
  
    return updatedInputString;
  }



jQuery('body').on('keyup change paste', '#hr-form input, #hr-form select, #hr-form textarea', function(e){
    e.preventDefault();

    var start_time = new Date().getTime();
    var paramsString = processFormForURL(jQuery('#hr-form').serializeArray());

    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('s');

    var breadcrumbs = null;
    var breadcrumbsQuery = "";

    // if current URL has the query "s=" in the querystring return
    if (window.location.href.indexOf("?s=") > 0) {
    } else {
        breadcrumbs = document.getElementById('hr-breadcrumbs').value.replace(/(&|&amp;| )/g, function(match) {
            if (match === ' ')
                return '%20';
            else
                return '%26';
        });

        if (breadcrumbs !== "null") {
            breadcrumbsQuery = "&breadcrumbs="+breadcrumbs
        }
    }

    let extra = "";
    const key_src = jQuery("#hr_key_src").val();

    if( key_src === "custom_field" ) {
        extra += "&key_src="+jQuery("#hr_key_src").data('post-id');
    }

    console.log("?hr-ajax&locale="+ajax_var.locale+"&query="+paramsString['filters']+breadcrumbsQuery+extra)

    jQuery(this).prop('disabled', true)
    jQuery(this).siblings().prop('disabled', true)
    jQuery("#hr-page-container").addClass('loading transition-opacity opacity-70 pointer-events-none').children('.spinner').first().removeClass('hidden')
    jQuery("#hr-options").addClass('loading transition-opacity opacity-70 pointer-events-none').children('.spinner').first().removeClass('hidden')

    if (window.location.href.indexOf("?s=") > -1) {
        getData("/" + "?hr-search-ajax&locale="+ajax_var.locale+"&query="+searchParam+"&filters="+paramsString['filters']).then(data => {
            var parsedData = JSON.parse(data);
            var html = new DOMParser().parseFromString(parsedData.html, "text/html");
            jQuery( '#hr-page' ).replaceWith( html.firstChild.innerHTML );
        }).catch((error) => {
            console.error(error);
        });
    } else {

        getData("/" + "?hr-ajax&locale="+ajax_var.locale+"&query="+paramsString['filters']+breadcrumbsQuery+extra).then(data => {
            var parsedData = JSON.parse(data);
            var html = new DOMParser().parseFromString(parsedData.html, "text/html");
            jQuery( '#hr-page' ).replaceWith( html.firstChild.innerHTML );
        }).catch((error) => {
            console.error(error);
        });
    }
    
});


async function getData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "same-origin", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    return response.text(); // parses JSON response into native JavaScript objects
}

// window.onload = function() {
//     console.log('loaded iframe')
//     window._klarnaCheckout(function(api) {
//         api.on({
//             'change': function(data) {




//                 // var country = '';
//                 // var currency = '';

//                 // if (data.country === 'swe') {
//                 //     country = 'SE';
//                 //     currency = 'SEK';
//                 // } else if (data.country === 'nor') {
//                 //     country = 'NO';
//                 //     currency = 'NOK';
//                 // } else if (data.country === 'dnk') {
//                 //     country = 'DK';
//                 //     currency = 'DKK';
//                 // } else if (data.country === 'deu') {
//                 //     country = 'DE';
//                 //     currency = 'EUR';
//                 // } else if (data.country === 'nld') {
//                 //     country = 'NL';
//                 //     currency = 'EUR';
//                 // } else if (data.country === 'ita') {
//                 //     country = 'IT';
//                 //     currency = 'EUR';
//                 // } else if (data.country === 'mlt') {
//                 //     country = 'MT';
//                 //     currency = 'EUR';
//                 // } else {
//                 //     country = 'SE';
//                 //     currency = 'SEK';
//                 // }

//                 // var kco_id = jQuery('#kco-id').val();

//                 // jQuery.ajax({
//                 //     url : ajax_var.ajax_url,
//                 //     type : 'post',
//                 //     data : {
//                 //         action : 'aelia_force_change_country',
//                 //         nonce : ajax_var.nonce,
//                 //         country : country,
//                 //         currency : currency,
//                 //         kco_id : kco_id
//                 //     },
//                 //     success : async function( response ) {
//                 //         console.log(response)

//                 //         const resp = await fetch(
//                 //             `https://api.klarna.com/checkout/v3/orders/${kco_id}`,
//                 //             {
//                 //             method: 'POST',
//                 //             headers: {
//                 //                 'Content-Type': 'application/json'
//                 //             },
//                 //             body: JSON.stringify({
//                 //                 purchase_currency: currency,
//                 //             })
//                 //             }
//                 //         );
                        
//                 //         const data = await resp.json();
//                 //         console.log(data);

//                 //     },
//                 //     error: function(errorThrown){
//                 //         console.log(errorThrown);
//                 //     }
//                 // });
//                 // return false;


//             }
//         });
//     });
//}








// Should update the cost fragment for the sidebar
// jQuery('body').on('kco_shipping_option_changed', function(event, data) {
//     console.log('shipping option changed')
//     jQuery('body').trigger('refresh_order_cost');
// });

// window.onload = function() {

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

window.onload = function() {
    return false;
    console.log('test')
    window._klarnaCheckout(function(api) {
        api.on({
            'change': function(data) {
                var country = '';
                var currency = '';

                switch (data.country) {
                    case 'swe':
                        country = 'SE';
                        currency = 'SEK';
                        break;
                    case 'nor':
                        country = 'NO';
                        currency = 'NOK';
                        break;
                    case 'fin':
                        country = 'FI';
                        currency = 'EUR';
                        break;
                    case 'dnk':
                        country = 'DK';
                        currency = 'DKK';
                        break;
                    case 'deu':
                        country = 'DE';
                        currency = 'EUR';
                        break;
                    case 'nld':
                        country = 'NL';
                        currency = 'EUR';
                        break;
                    case 'aut':
                        country = 'AT';
                        currency = 'EUR';
                        break;
                    case 'bel':
                        country = 'BE';
                        currency = 'EUR';
                        break;
                    case 'esp':
                        country = 'ES';
                        currency = 'EUR';
                        break;
                    case 'fra':
                        country = 'FR';
                        currency = 'EUR';
                        break;
                    case 'irl':
                        country = 'IE';
                        currency = 'EUR';
                        break;
                    case 'ita':
                        country = 'IT';
                        currency = 'EUR';
                        break;
                    case 'mlt':
                        country = 'MT';
                        currency = 'EUR';
                        break;
                    default:
                        country = 'SE';
                        currency = 'SEK';
                        break;
                }

                const old_country = getCookie('aelia_customer_country') 
                const old_currency = getCookie('aelia_cs_selected_currency')

                if (old_country === country && old_currency === currency) {
                    console.log('Country and currency are the same, no changes needed');
                    return;
                } else {
                    console.log('Country and currency are different, changing country and currency');
                    console.log('Old country: ' + old_country + ' | Old currency: ' + old_currency);
                    console.log('New country: ' + country + ' | New currency: ' + currency);
                }

                // document.cookie = `aelia_customer_country=${country}; path=/; max-age=${86400 * 30}`;
                // document.cookie = `aelia_cs_shipping_pricing_settings_currency=${currency}; path=/; max-age=${86400 * 30}`;
                // document.cookie = `aelia_cs_selected_currency=${currency}; path=/; max-age=${86400 * 30}`;
                
                
                
                jQuery.ajax({
                    url: ajax_var.ajax_url,
                    type: 'post',
                    data: {
                        action: 'aelia_force_change_country',
                        nonce: ajax_var.nonce,
                        country: country,
                        currency: currency,
                        kco_id: kco_id
                    },
                    success: function (response) {

                        api.resume();
                        console.log("Country and currency changed");
            
                        //location.reload();
                    },
                    error: function(errorThrown) {
                        console.log(errorThrown);
                    }
                });
            }
        });
    });
};